<template lang="html">
    <section class="">
    <b-row class="">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="12" md="12">
        <b-card-actions action-collapse title="Edit Booking">
          <b-row class="">
            <b-col cols="12" xl="6" md="6" class="mt-15">
              <h5>Document type</h5>
              <b-form-group label-for="document-type">
                <v-select
                  id="document-type"
                  placeholder="Select Document type"                          
                  v-model="form.documentType"
                  :options="DocumentType"
                  required/>
              </b-form-group>                           
            </b-col>
            <b-col cols="12" xl="6" md="6" class="mt-15">
              <h5>Deliver the Bill of Lading</h5>
              <b-form-group label-for="connaissement">
                <v-select
                  id="connaissement"
                  placeholder="Select Bill of Lading"                          
                  v-model="form.receiverAgent"
                  :options="connaissement"
                  required/>
              </b-form-group>                           
            </b-col>
            <b-col cols="12" xl="12" md="12" class="mt-15">
              <h5>Cargo Details</h5>
            </b-col>
          </b-row>
          <b-row v-for="(item, index) in form.cargoDetails" :key="index">
            <b-col lg="6" md="6" sm="6" xs="12" cols="12">
              <h5>Number Of Packages</h5>
              <b-form-group label-for="packagesNumber">
                <b-form-input
                id="packagesNumber"
                v-model="item.packagesNumber"
                placeholder="Number of packages"
                type="number"
                required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="6" xs="12" cols="12">
              <h5>Kind of packages</h5>
              <b-form-group label-for="packagesKind">
                <b-form-input
                id="packagesKind"
                v-model="item.packagesKind"
                placeholder="Kind of packages"
                required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" sm="12" xs="12" cols="12">
              <h5>Cargo Description</h5>
              <b-form-group label-for="CargoDescription">
                <b-form-textarea
                rows="3"
                max-rows="6"
                id="CargoDescription"
                v-model="item.cargoDescription"
                placeholder="Cargo Description"
                required
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col lg="4" md="4" sm="6" xs="12" cols="12">
              <h5>HS Code</h5>
              <b-form-group label-for="HSCode">
                <b-form-input
                id="HSCode"
                v-model="item.HSCode"
                placeholder="HS Code"
                required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4" md="4" sm="6" xs="12" cols="12">
              <h5>Weight of Merchandise</h5>
              <b-form-group label-for="merchandiseWeight">
                <v-select
                id="merchandiseWeight"
                placeholder="Select Weight of Merchandise"                          
                v-model="item.merchandiseWeight"
                :options="weightOfMerchandise"
                required/>
              </b-form-group>
            </b-col> 
            <b-col lg="4" md="4" sm="6" xs="12" cols="12">
              <h5>Seal number</h5>
              <b-form-group label-for="sealNumber ">
                <b-form-input
                  id="sealNumber"
                  v-model="item.sealNumber"
                  placeholder="Seal number"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4" md="4" sm="6" xs="12" cols="12">
              <h5>Containers liste</h5>
              <b-form-group label-for="container">
                <v-select
                id="container"
                placeholder="Select Container"                          
                v-model="item.container"
                :options="containersTab"
                required
                @input="updateContainer(index,item.container)"/>
              </b-form-group>
            </b-col>
            <b-col lg="4" md="4" sm="6" xs="12" cols="12">
              <h5>Container Quantity</h5>
              <b-form-group label-for="Container-qte">
                <b-form-spinbutton 
                id="Container-qte" 
                v-model="item.quantity"
                min="1" 
                max="100000"
                ></b-form-spinbutton> 
              </b-form-group>
            </b-col>
            <b-col lg="4" md="4" sm="6" xs="12" cols="12">
              <h5>Container number</h5>
              <b-form-group label-for="containerNumber">
                <b-form-input
                  id="containerNumber"
                  size="11"
                  v-model="item.containerNumber"
                  placeholder="Container number"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="2" md="2" sm="12" xs="12" cols="12" v-if="index > maxLength-1">
              <b-button variant="danger" class="delete-container" @click="deleteCargo(index)">Delete</b-button>
            </b-col>
            <b-col v-if="index !== form.cargoDetails.length-1"><br><hr class="cargo-line"><br></b-col>
          </b-row>
          <b-row>
              <b-col>
                <b-button  variant="primary" class="addCargo" @click="addCargo()">
                  Add Cargo Detail
                </b-button>
              </b-col>
          </b-row>
          <b-col cols="12" xl="12" md="12" class="mt-3">
            <h4>Parties</h4>
          </b-col>
          <b-row v-for="(partyType,j) in partyTypes" :key="`${partyType}-${j}`">
            <b-col lg="12" md="12" sm="12" xs="12" cols="12" class="mb-2"><span class="party-title">{{ listParties[j] }}</span></b-col>
            <b-col lg="12" md="12" sm="12" xs="12" cols="12">
              <h5>Company Name</h5>
              <b-form-group label-for="companyName">
                <b-form-input
                id="companyName"
                v-model="form.parties[partyType].companyName"
                placeholder="Company Name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="6" xs="12" cols="12">
              <h5>Address (Optional)</h5>
              <b-form-group label-for="address">
                <b-form-input
                id="address"
                v-model="form.parties[partyType].address"
                placeholder="Address (Optional)"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="6" xs="12" cols="12">
              <h5>Contact (Optional)</h5>
              <b-form-group label-for="contact">
                <b-form-input
                id="contact"
                v-model="form.parties[partyType].contact"
                placeholder="Contact"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="6" xs="12" cols="12">
              <h5>Email (Optional)</h5>
              <b-form-group label-for="email">
                <b-form-input
                id="email"
                v-model="form.parties[partyType].email"
                placeholder="Email"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="6" xs="12" cols="12">
              <h5>Tel (Optional)</h5>
              <b-form-group label-for="tel">
                <b-form-input
                id="tel"
                v-model="form.parties[partyType].tel"
                placeholder="Tel"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col><br></b-col>
          </b-row> 
          <b-col cols="12" xl="12" md="12" class="mt-3">
            <h4>Payment Details</h4>
          </b-col> 
          <b-row class="mt-25">
            <b-col cols="12" xl="12" md="12" class="mt-3">
              <h5>FRET</h5>
            </b-col>
            <b-col cols="12" xl="4" md="4">
              <v-select
                placeholder="Payment Type"
                v-model="paymentFRET.paymentType"
                :options="paiementType"
              ></v-select>
            </b-col>
            <b-col cols="12" xl="4" md="4" v-if="paymentFRET.paymentType !== null"> 
              <v-select
              placeholder="Payment Country"
              v-model="paymentFRET.paymentCountry"
              :options="paiementCountry"
              />
            </b-col>
            <b-col cols="12" xl="4" md="4" v-if="paymentFRET.paymentType !== null">
              <b-form-input
                v-model="paymentFRET.invoiceDetails"
                placeholder="Inovoice Details"
              ></b-form-input>
            </b-col>
            <b-col cols="12" xl="12" md="12" class="mt-1">
              <b-button @click="chooseOffre('fret',paymentFRET)">Choose This Offer</b-button>
            </b-col>
          </b-row>  
          <b-row class="mt-25">
            <b-col cols="12" xl="12" md="12" class="mt-3">
              <h5>LTHC</h5>
            </b-col>
            <b-col cols="12" xl="4" md="4">
              <v-select
                placeholder="Payment Type"
                v-model="paymentLTHC.paymentType"
                :options="paiementType"
              ></v-select>
            </b-col>
            <b-col cols="12" xl="4" md="4" v-if="paymentLTHC.paymentType !== null"> 
              <v-select
              placeholder="Payment Country"
              v-model="paymentLTHC.paymentCountry"
              :options="paiementCountry"
              />
            </b-col>
            <b-col cols="12" xl="4" md="4" v-if="paymentLTHC.paymentType !== null">
              <b-form-input
                v-model="paymentLTHC.invoiceDetails"
                placeholder="Inovoice Details"
              ></b-form-input>
            </b-col>
            <b-col cols="12" xl="12" md="12" class="mt-1">
              <b-button @click="chooseOffre('lthc',paymentLTHC)">Choose This Offer</b-button>
            </b-col>
          </b-row> 
          <b-row class="mt-25">
            <b-col cols="12" xl="12" md="12" class="mt-3">
              <h5>DTHC</h5>
            </b-col>
            <b-col cols="12" xl="4" md="4">
              <v-select
                placeholder="Payment Type"
                v-model="paymentDTHC.paymentType"
                :options="paiementType"
              ></v-select>
            </b-col>
            <b-col cols="12" xl="4" md="4" v-if="paymentDTHC.paymentType !== null"> 
              <v-select
              placeholder="Payment Country"
              v-model="paymentDTHC.paymentCountry"
              :options="paiementCountry"
              />
            </b-col>
            <b-col cols="12" xl="4" md="4" v-if="paymentDTHC.paymentType !== null">
              <b-form-input
                v-model="paymentDTHC.invoiceDetails"
                placeholder="Inovoice Details"
              ></b-form-input>
            </b-col>
            <b-col cols="12" xl="12" md="12" class="mt-1">
              <b-button @click="chooseOffre('dthc',paymentDTHC)">Choose This Offer</b-button>
            </b-col>
          </b-row>  
          <b-col class="text-right mt-30" cols="12" xl="12" md="12">
            <b-button  variant="primary" class="addContainer" @click="onSubmit()">
            Save
            </b-button>
          </b-col>    


          <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Upload PDF</h5>
              </b-col>
               <b-col cols="12" xl="10" md="10" >
                    <b-form-file
            placeholder ="PDF"
            type="file"
            v-model="file"
            name="file"
            accept=".pdf"
          ></b-form-file>
            </b-col>
                  <b-col cols="12" xl="2" md="2">
               <b-button size="md" class="" v-if="form.pdf && form.pdf!=null && form.pdf!=undefined" @click="downloadFile(form.pdf)"> <feather-icon icon="DownloadIcon" size="18"/></b-button>
            </b-col>
               <b-col class="text-right mt-30">
                    <b-button  variant="primary" class="addContainer" @click="downloadFile()">
                      Save PDF
                    </b-button>
              </b-col>  


        </b-card-actions>
      </b-col>
    </b-row>
    </section>
</template>
<script>
import countriesList from '../../../Country.json';
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormFile,
  BFormSpinbutton,
  BFormDatepicker,
  BFormRadioGroup,
  BFormRadio
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SidebarAddNewCustomer from "../../composants/sidebar/SidebarAddNewCustomer.vue";
import SidebarAddNewAgency from "../../composants/sidebar/SidebarAddNewAgency.vue";
import SidebarAddNewCommodity from "../../composants/sidebar/SidebarAddNewCommodity.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "@axios";
export default {
  name: "BLForm",
  components: {
    BFormFile,
    BFormDatepicker,
    BFormSpinbutton,
    BCardActions,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    SidebarAddNewCustomer,
    SidebarAddNewAgency,   
    SidebarAddNewCommodity,
    ToastificationContent,
    BFormRadioGroup,
    BFormRadio
  },
  data() {
    return {
      file : null,
      form: {
        customer:JSON.parse(localStorage.getItem("userData"))._id,
        booking:this.$router.history.current.query.id,
        documentType: null,
        receiverAgent: null,
        cargoDetails :
        [
          {
            packagesNumber: "",
            packagesKind: "",
            cargoDescription: "",
            HSCode: "",
            container: null,
            quantity : 1,
            containerNumber: "",
            sealNumber: "",
            merchandiseWeight: null,
          }      
        ],
        parties: {
          shipper : {
            companyName : "",
            address : "",
            contact : "",
            email : "",
            tel : ""
          },
          consignee : {
            companyName : "",
            address : "",
            contact : "",
            email : "",
            tel : ""
          },
          notifyParty : {
            companyName : "",
            address : "",
            contact : "",
            email : "",
            tel : ""
          },
          outwardForwarder : {
            companyName : "",
            address : "",
            contact : "",
            email : "",
            tel : ""
          },
        },
        payment: {
          paymentName:'',
          paymentType:null,
          paymentCountry:null,
          invoiceDetails:""
        } 
      },
      paymentFRET : {
        paymentName:'',
        paymentType:null,
        paymentCountry:null,
        invoiceDetails:""         
      },
      paymentLTHC : {
        paymentName:'',
        paymentType:null,
        paymentCountry:null,
        invoiceDetails:""         
      },
      paymentDTHC : {
        paymentName:'',
        paymentType:null,
        paymentCountry:null,
        invoiceDetails:""         
      },
      paiementType:["Prepaid", "Collect", "Other"],
      paiementCountry: [],
      DocumentType: [
        "xls",
        "pdf",
        "docx",
      ],
      connaissement: [
        "C1",
        "C2",
        "C3",
        "C4",
      ],
      partyTypes: ["shipper", "consignee", "notifyParty", "outwardForwarder"],
      listParties: ["Shipper","Consignee","Notify Party","Outward Forwarder"],
      weightOfMerchandise: [
        "Net",
        "VGM",
      ],
      containersTab:[],
      show: true,
      maxLength : null,
      acceptTerm: false,
    };
  },
  async created() {
    await this.getDataBL()
    await this.getContainers()
    this.getCountries()
  },
  methods: {
    async getDataBL() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/bls?id="+ this.$router.history.current.query.id
      );
      this.form = response.data.data
      if (this.form.payment.paymentName.toUpperCase() === "FRET") {
        this.paymentFRET = this.form.payment
      }
      else if (this.form.payment.paymentName.toUpperCase() === "LTHC") {
        this.paymentLTHC = this.form.payment
      }
      else {
        this.paymentDTHC = this.form.payment
      }
      this.maxLength = response.data.data.booking.commodityContainer.length
    },
    async getContainers() {
        const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/containers"); 
        this.containersTab = response.data.data.map(item => ({
          label: item.title+" "+item.type,
          value: {"_id": item._id , "title": item.title},
        }));
    },
    getCountries() { 
      countriesList.forEach(country => {
        this.paiementCountry.push(country.name)
      });
    },
    updateContainer(index,container) {
      if (container) {
        this.form.cargoDetails[index].container = container.label
      }
    },
    addCargo() {
      this.form.cargoDetails.push({
        packagesNumber: "",
        packagesKind: "",
        cargoDescription: "",
        HSCode: "",
        container: null,
        quantity : 1,
        containerNumber: "",
        sealNumber: "",
        merchandiseWeight: null,      
      })
    },
    deleteCargo(index) {
      this.form.cargoDetails.splice(index,1)
    },
    chooseOffre(name,payment) {
      this.form.payment = payment
      this.form.payment.paymentName = name
      if (Object.values(this.form.payment).some(value => value === '' || value === null)) {
        this.$toast({
                component: ToastificationContent,
                  props: {
                    title: "Fill out the form with the required information",
                    icon: "EditIcon",
                    variant: "warning",
                  },
        });  
        
      }
      else {
        this.$toast({
                component: ToastificationContent,
                  props: {
                    title: "Your offer is well selected, please check your information then validate the B/L",
                    icon: "EditIcon",
                    variant: "success",
                  },
        });  
      }
    },
    validData() {
      const hasEmpty = (this.form.documentType === "" || this.form.documentType === null) ||
      (this.form.receiverAgent === "" || this.form.receiverAgent === null)
      const cargoEmpty = this.form.cargoDetails.some(element => {
        return Object.values(element).some(value => value === '' || value === null);
      });
      const partiesEmpty = this.form.parties.shipper.companyName === "" || this.form.parties.shipper.companyName === null &&
      this.form.parties.consignee.companyName === "" || this.form.parties.consignee.companyName === null &&
      this.form.parties.notifyParty.companyName === "" || this.form.parties.notifyParty.companyName === null &&
      this.form.parties.outwardForwarder.companyName === "" || this.form.parties.outwardForwarder.companyName === null
      return cargoEmpty===false && hasEmpty===false && partiesEmpty===false && 
      (Object.values(this.form.payment).some(value => value === '' || value === null)) ===false
    },
        async uploadFile() {
      if (!this.file) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Please select a file`,
            icon: "UserIcon",
            variant: "warning",
          },
        });      
      }
      else {
        const allowedExtensions = ['.pdf'];
        const fileExtension = this.file.name.slice(this.file.name.lastIndexOf('.'));
        if (!allowedExtensions.includes(fileExtension)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `PDF file only`,
              icon: "UserIcon",
              variant: "warning",
            },
          }); 
        }
        else {
          const formData = new FormData();
          formData.append("pdf",this.file)
          try {
            const response = await axios.put(`https://mtl-feeder-nodejs.onrender.com/api/bls/${this.$router.history.current.query.id}`, formData ,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              });
              this.getAllDataBL()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `File submitted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });             
            } catch (error) {
              console.error(error);
            }
        }
      }
    },
    downloadFile(url) {
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = "File.pdf";  
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    onSubmit() {
      const id = this.$router.history.current.query.id
        axios
        .put(
          `https://mtl-feeder-nodejs.onrender.com/api/bls/${id}`, this.form
            )
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                  props: {
                    title: "BL Updated",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });  
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                  props: {
                    title: "Error during update",
                    icon: "EditIcon",
                    variant: "error",
                  },
                });  
            })
    },
  },
};
</script>
<style lang="css" scoped>
.bl-box-form {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bl-form {
  color: #053091;
  background: #f3f3f3;
  border-radius: 12px 12px 12px 12px;
  padding: 1.5rem 0.5rem 0.5rem 0.5rem;
  width: 100%;
  height: auto;
}
/* .row {
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 1.2rem !important;
} */
.btnReset {
  color: #053091 !important;
  background: #e7b31e !important;
  border: none;
  border-radius: 12px 12px 12px 12px !important;
  padding: 0.5rem 1rem;
  font-size: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.btnSubmit {
  color: white !important;
  background: #053091 !important;
  border: none;
  border-radius: 12px 12px 12px 12px !important;
  padding: 0.5rem 1rem;
  font-size: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.addRequest {
  background-color: #fff;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.words-divider {
  border: 1px solid;
  border-radius: 10px 10px 10px 10px;
  padding-top: 8px;
  color: white;
  background-color: #053091;
  height: 40px;
}
.words-divider p {
  font-weight: 500;
}

.cercle-steps {
  border: 2px solid #053091;
  color: #053091;
  border-radius: 50%;
  padding: 0.05rem 0.35rem;
  margin-right: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  justify-content: center;
  align-items: center;
}
.bl-form .nav-tabs .nav-link.active .cercle-steps {
  color: #e7b31e !important;
  border-color: #e7b31e !important;
}
.bl-form .nav-tabs .nav-link.active span {
  color: #e7b31e !important;
}
.linkAccept  {
    color: #053091!important;
    text-decoration: underline !important;
}
.cargo-line {
  background-color: #495057!important;
}
.party-title {
  font-size: 15px;
  color:#555555;
}
.payment-select{
  border-bottom : 2px solid white !important
}
.invoice {
  color: white !important;
}
.invoice::placeholder {
  color: white;
}
.addCargo {
  margin-top: 10px;
    border: none;
}

.delete-container {
    color: red;
    border: none;
}
.delete-container-div{
    height: 100%;
    display: flex;
    margin-bottom: 15px;
}
.delete-container,.addCargo {
    background-color: transparent;
}
@media only screen and (max-width: 575px) {
  .btn-footer-forms .ml-25 {
    margin-left: 0px !important;
  }
}
/* cards */


.container-paiment {
    position: relative;
}

.container-paiment .card {
    position: relative;
    width: 100%;
    height: 500px;
    background: #053091;
    border-radius: 20px;
    overflow: hidden;
}

.container-paiment .card:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #e7b31e;
    /*clip-path: circle(150px at 80% 20%);
    transition: 0.5s ease-in-out;*/
    clip-path: circle(270px at 80% -20%);
}

/*.container-paiment .card:hover:before {
    clip-path: circle(300px at 80% -20%);
}*/

.container-paiment .card:after {
    content: "MTL";
    position: absolute;
    top: 25%;
    left: -5%;
    font-size: 12em;
    font-weight: 800;
    font-style: italic;
    color: rgba(255, 255, 255, 0.04);

}

.container-paiment .card .imgBx {
    position: absolute;
    /*top: 40%;
    transform: translateY(-50%);*/
    z-index: 1000;
    width: 100%;
    height:  52%;
    /*transition: .5s;*/
    top: 0%;
    transform: translateY(-25%);
}

/*.container-paiment .card:hover .imgBx {
    top: 0%;
    transform: translateY(-25%);
    /* bug  */
/*}*/

.container-paiment .card .imgBx img {
    position: absolute;
    top: 50%;
    left: 55%;
    transform: translate(-50%, -50%) rotate(20deg);
    width: 170px;
}

.container-paiment .card .contentBx {
    position: absolute;
    bottom: 0;
    width: 100%;
    /*height: 100px;*/
    height: 310px;
    text-align: center;
    transition: 1s;
    z-index: 90;
}

/*.container-paiment .card:hover .contentBx {
    height: 280px;
}*/

.container-paiment .card .contentBx h2 {
    position: relative;
    font-weight: 600;
    letter-spacing: 1px;
    color: #fff;
}

.container-paiment .card .contentBx .country {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 20px;
    transition: .5s;
    /*opacity: 0;
    visibility: hidden;*/
}

/*.container-paiment .card:hover .contentBx .country {
    opacity: 1;
    visibility: visible;
    transition-delay: .5s;
}*/

.container-paiment .card .contentBx button {
    display: inline-block;
    padding: 7px 16px;
    background: #fff;
    border-radius: 4px;
    text-decoration: none;
    font-weight: 600;
    color: #111;
   /* opacity: 0;*/
    transform: translateY(50px);
    transition: .5s;
    border:none!important
}

/*.container-paiment .card:hover .contentBx button {
    opacity: 1;
    transform: translateY(0px);
    transition-delay: .7s;
} */

</style>